export default __webpack_public_path__ + "static/media/vector.3c6eb054.png";